import ApiService from "./api.service";

const UtilitiesService = {
  /**
   * Translates a given payload on demand using the LLM backend utility.
   * Now targets api-v2 (modular monolith). The success envelope is
   * wire-compatible with the legacy endpoint, so callers keep reading
   * `response.data` the same way.
   * @param {Object} payload
   * @param {string} payload.sourceLang - "es" or "en"
   * @param {string} payload.targetLang - "es" or "en"
   * @param {string} [payload.context] - optional context for the LLM
   * @param {Object} payload.data - data to translate
   * @returns {Promise<Object>} The response data with the translated fields
   */
  translate: async function (payload = {}, lang = null) {
    const response = await ApiService.post("api/v2/utilities/translate", payload, lang);
    return response.data;
  },
};

export default UtilitiesService;
